import React from 'react';
import { ModuleBridge } from '../components';
import { ViewMigrationsTopBar } from '../components/ViewMigrationsTopBar';

export const ScheduledMigrations = () => {
    return (
        <>
            <ViewMigrationsTopBar />
            <div id="scheduled_migrations_container"></div>
            <ModuleBridge moduleId="scheduled_migrations_module" />
        </>
    );
};
